module.exports = __webpack_public_path__ + "img/desarrollo_marca.faf13288.svg";